import { clsx } from 'clsx';

export const APP_BG_COLOR = 'tw:bg-zinc-50';
export const STICKY_HEADER = clsx('tw:sticky', 'tw:top-0', 'tw:z-10', APP_BG_COLOR);
